import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getNote } from '../services/notes';
import type { Note } from '../types';

interface UseNoteReturn {
  note: Note | null;
  loading: boolean;
  error: { message: string; type: 'error' | 'success' | 'info' } | null;
}

export default function useNote(shortId: string | undefined): UseNoteReturn {
  const { t } = useTranslation();
  const [note, setNote] = useState<Note | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<{ message: string; type: 'error' | 'success' | 'info' } | null>(null);

  useEffect(() => {
    async function fetchNote() {
      try {
        if (!shortId) throw new Error(t('viewNote.errors.notFound.message'));
        const fetchedNote = await getNote(shortId);
        setNote(fetchedNote);
        setError(null);
      } catch (err) {
        setError({
          message: err instanceof Error ? err.message : t('viewNote.errors.notFound.message'),
          type: 'error'
        });
      } finally {
        setLoading(false);
      }
    }

    fetchNote();
  }, [shortId, t]);

  return { note, loading, error };
}